export default __webpack_public_path__ + "static/media/woodworking.4a33a0e4.png";